/* =========================================================
   AZURE CLUB — Página de producto
   Selector de opciones (una fila por opción), packs con
   elección de pieza y envío múltiple al carrito.
   Sin dependencias.
   ========================================================= */
(function () {
  'use strict';

  var form = document.getElementById('ProductForm');
  if (!form) return;

  var variantInput = form.querySelector('[data-variant-input]');
  var packSelector = form.querySelector('[data-pack-selector]');
  var addButton = form.querySelector('[data-add-button]');
  var buttonPrice = form.querySelector('[data-button-price]');
  var priceEl = document.querySelector('[data-price]');
  var stickyPrice = document.querySelector('[data-sticky-price]');

  var optionGroups = form.querySelectorAll('[data-option-group]');
  var variantMapTag = form.querySelector('[data-variant-map]');
  var variantMap = [];
  try {
    if (variantMapTag) variantMap = JSON.parse(variantMapTag.textContent) || [];
  } catch (err) {
    variantMap = [];
  }

  var picker = document.querySelector('[data-pack-picker]');
  var pickerGrid = document.querySelector('[data-pack-grid]');
  var catalogTag = document.querySelector('[data-pack-catalog]');
  var catalog = [];
  var activeSlot = null;

  try {
    if (catalogTag) catalog = JSON.parse(catalogTag.textContent) || [];
  } catch (err) {
    catalog = [];
  }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var parts = value.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',') + ' €';
  }

  /* ---------- Selección de opciones ---------- */
  var selected = [];

  Array.prototype.forEach.call(optionGroups, function (group) {
    var idx = parseInt(group.getAttribute('data-option-index'), 10);
    var current = group.querySelector('[data-option-value].is-selected');
    selected[idx] = current ? current.getAttribute('data-value') : null;
  });

  function matches(variant, values, ignoreIndex) {
    for (var i = 0; i < values.length; i++) {
      if (i === ignoreIndex) continue;
      if (!values[i]) continue;
      if (variant.options[i] !== values[i]) return false;
    }
    return true;
  }

  function findVariant(values) {
    for (var i = 0; i < variantMap.length; i++) {
      if (matches(variantMap[i], values, -1)) return variantMap[i];
    }
    return null;
  }

  /* Una talla se marca agotada si, con el resto de opciones elegidas,
     no existe ninguna variante disponible. */
  function refreshAvailability() {
    Array.prototype.forEach.call(optionGroups, function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      Array.prototype.forEach.call(group.querySelectorAll('[data-option-value]'), function (pill) {
        var test = selected.slice();
        test[idx] = pill.getAttribute('data-value');
        var found = false;
        for (var i = 0; i < variantMap.length; i++) {
          if (variantMap[i].available && matches(variantMap[i], test, -1)) { found = true; break; }
        }
        if (found) {
          pill.classList.remove('is-unavailable');
          pill.removeAttribute('aria-disabled');
        } else {
          pill.classList.add('is-unavailable');
          pill.setAttribute('aria-disabled', 'true');
        }
      });
    });
  }

  function syncGallery(variant) {
    if (!variant || variant.mediaIndex === null || variant.mediaIndex === undefined) return;
    var thumb = document.querySelector('[data-gallery-thumb][data-index="' + variant.mediaIndex + '"]');
    if (thumb && !thumb.classList.contains('is-active')) thumb.click();
  }

  function applyVariant() {
    var v = findVariant(selected);
    refreshAvailability();
    if (!v) return;

    if (variantInput) variantInput.value = v.id;
    if (priceEl) priceEl.textContent = formatMoney(v.price);
    if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);

    syncGallery(v);

    if (addButton) {
      addButton.disabled = !v.available;
      var label = addButton.querySelector('span');
      if (label) label.textContent = v.available ? (addButton.getAttribute('data-label') || 'Añadir a mi cesta') : 'Agotado';
    }

    // La primera unidad de cada pack sigue a la variante elegida arriba
    if (packSelector) {
      Array.prototype.forEach.call(packSelector.querySelectorAll('[data-pack-option]'), function (opt) {
        var firstSlot = opt.querySelector('[data-pack-slot]');
        if (!firstSlot) return;
        var control = firstSlot.querySelector('[data-pack-variant]');
        if (control) control.value = v.id;
        firstSlot.setAttribute('data-price', v.price);
        recalc(opt);
      });
    }
    updateButton();
  }

  Array.prototype.forEach.call(optionGroups, function (group) {
    var idx = parseInt(group.getAttribute('data-option-index'), 10);
    var label = group.querySelector('[data-option-current]');

    Array.prototype.forEach.call(group.querySelectorAll('[data-option-value]'), function (pill) {
      pill.addEventListener('click', function () {
        Array.prototype.forEach.call(group.querySelectorAll('[data-option-value]'), function (p) {
          p.classList.remove('is-selected');
        });
        pill.classList.add('is-selected');
        selected[idx] = pill.getAttribute('data-value');
        if (label) label.textContent = selected[idx];
        applyVariant();
      });
    });
  });

  if (optionGroups.length) {
    if (addButton) {
      var initial = addButton.querySelector('span');
      if (initial) addButton.setAttribute('data-label', initial.textContent);
    }
    refreshAvailability();
  }

  /* ---------- Cálculo de precio del tramo ---------- */
  function recalc(opt) {
    var pct = parseInt(opt.getAttribute('data-pct'), 10) || 0;
    var qty = parseInt(opt.getAttribute('data-qty'), 10) || 1;
    var slots = opt.querySelectorAll('[data-pack-slot]');
    var subtotal = 0;

    Array.prototype.forEach.call(slots, function (slot) {
      var p = parseInt(slot.getAttribute('data-price'), 10);
      if (!isNaN(p)) subtotal += p;
    });

    /* Ofertas de importe cerrado, del tipo "3 mocasines por 99,95 €".

       data-fixed-off es el descuento EN CÉNTIMOS que aplica de verdad el
       descuento automático de Shopify. Se usa en lugar del porcentaje
       porque un porcentaje redondeado no puede dar el precio anunciado:
       3 × 49,95 × 0,67 = 100,40 €, no 99,95 €.

       Al restar el mismo importe que resta la caja, lo que se enseña aquí
       y lo que se cobra al pagar coinciden al céntimo, incluso si el
       cliente cambia alguna pieza del pack por otra de distinto precio. */
    var fixedOff = parseInt(opt.getAttribute('data-fixed-off'), 10);
    var discounted;
    if (!isNaN(fixedOff) && fixedOff > 0) {
      discounted = Math.max(0, subtotal - fixedOff);
    } else {
      discounted = Math.round(subtotal * (100 - pct) / 100);
    }

    var perUnit = Math.round(discounted / qty);
    var perUnitFull = Math.round(subtotal / qty);

    opt.setAttribute('data-grand-total', discounted);

    var totalEl = opt.querySelector('[data-pack-total]');
    var fullEl = opt.querySelector('[data-pack-full]');
    var grandEl = opt.querySelector('[data-pack-grand-total]');
    if (totalEl) totalEl.textContent = formatMoney(perUnit);
    if (fullEl) fullEl.textContent = formatMoney(perUnitFull);
    if (grandEl) grandEl.textContent = formatMoney(discounted) + ' en total';

    /* La nota del tramo también lleva el total cuando es oferta cerrada */
    var noteEl = opt.querySelector('[data-pack-note]');
    if (noteEl && !isNaN(fixedOff) && fixedOff > 0 && qty > 1) {
      noteEl.textContent = formatMoney(discounted) + ' el pack';
    }

    if (opt.classList.contains('is-selected')) updateButton();
  }

  /* ---------- Selección de tramo ---------- */
  function selectedOption() {
    if (!packSelector) return null;
    return packSelector.querySelector('[data-pack-option].is-selected');
  }

  /* El pago rápido solo vale para 1 unidad: los packs se montan con varias
     referencias vía /cart/add.js y ese botón salta directo al pago. */
  function updateExpressCheckout() {
    var express = document.querySelector('[data-express-checkout]');
    if (!express) return;
    var opt = selectedOption();
    var qty = opt ? parseInt(opt.getAttribute('data-qty'), 10) || 1 : 1;
    express.hidden = qty !== 1;
  }

  function updateButton() {
    updateExpressCheckout();
    if (!buttonPrice) return;
    var opt = selectedOption();
    if (!opt) {
      var v = findVariant(selected);
      if (v) buttonPrice.textContent = formatMoney(v.price);
      return;
    }
    var grand = opt.getAttribute('data-grand-total');
    if (grand !== null) buttonPrice.textContent = formatMoney(parseInt(grand, 10));
  }

  if (packSelector) {
    Array.prototype.forEach.call(packSelector.querySelectorAll('[data-pack-option]'), function (opt) {
      var radio = opt.querySelector('[data-pack-radio]');

      opt.addEventListener('click', function (e) {
        var tag = e.target.tagName;
        if (tag === 'SELECT' || tag === 'OPTION' || tag === 'BUTTON') return;
        Array.prototype.forEach.call(packSelector.querySelectorAll('[data-pack-option]'), function (o) {
          o.classList.remove('is-selected');
        });
        opt.classList.add('is-selected');
        if (radio) radio.checked = true;
        updateButton();
      });

      opt.addEventListener('change', function (e) {
        if (!e.target.matches('[data-pack-variant]')) return;
        var slot = e.target.closest('[data-pack-slot]');
        var chosen = e.target.options ? e.target.options[e.target.selectedIndex] : null;
        if (slot && chosen) {
          var p = parseInt(chosen.getAttribute('data-price'), 10);
          if (!isNaN(p)) slot.setAttribute('data-price', p);
          slot.classList.remove('has-error');
        }
        recalc(opt);
      });

      recalc(opt);
    });
    updateButton();
  }

  /* ---------- Panel de elección de pieza ---------- */
  function variantLabel(product, v) {
    var names = product.optionNames || [];
    if (names.length > 1 && v.options && v.options.length) {
      return v.options.map(function (val, i) {
        return (names[i] ? names[i] + ' ' : '') + val;
      }).join(' · ');
    }
    return v.title;
  }

  function buildPicker() {
    if (!pickerGrid || pickerGrid.childNodes.length) return;

    catalog.forEach(function (p, index) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pack-pick';
      btn.setAttribute('data-pack-index', index);

      var img = document.createElement('img');
      img.src = p.image || '';
      img.alt = '';
      img.loading = 'lazy';

      var title = document.createElement('span');
      title.className = 'pack-pick__title';
      title.textContent = p.title;

      var price = document.createElement('span');
      price.className = 'pack-pick__price';
      price.textContent = formatMoney(p.price);

      btn.appendChild(img);
      btn.appendChild(title);
      btn.appendChild(price);
      pickerGrid.appendChild(btn);
    });
  }

  function openPicker(slot) {
    if (!picker) return;
    activeSlot = slot;
    buildPicker();
    picker.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  function closePicker() {
    if (!picker) return;
    picker.hidden = true;
    activeSlot = null;
    document.documentElement.style.overflow = '';
  }

  function fillSlot(slot, product) {
    var available = (product.variants || []).filter(function (v) { return v.available; });
    if (!available.length) return;
    var first = available[0];

    var media = slot.querySelector('.pack-slot__media');
    var title = slot.querySelector('.pack-slot__title');
    var control = slot.querySelector('.pack-slot__control');
    if (!media || !title || !control) return;

    media.className = 'pack-slot__media';
    media.textContent = '';
    if (product.image) {
      var img = document.createElement('img');
      img.src = product.image;
      img.alt = '';
      img.loading = 'lazy';
      media.appendChild(img);
    }

    title.className = 'pack-slot__title';
    title.textContent = product.title;

    control.textContent = '';

    if (product.onlyDefault) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.setAttribute('data-pack-variant', '');
      hidden.value = first.id;
      control.appendChild(hidden);
    } else {
      var select = document.createElement('select');
      select.setAttribute('data-pack-variant', '');
      select.setAttribute('aria-label', 'Talla de ' + product.title);
      product.variants.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v.id;
        o.textContent = variantLabel(product, v) + (v.available ? '' : ' · Agotado');
        o.setAttribute('data-price', v.price);
        if (!v.available) o.disabled = true;
        if (v.id === first.id) o.selected = true;
        select.appendChild(o);
      });
      control.appendChild(select);
    }

    var change = document.createElement('button');
    change.type = 'button';
    change.className = 'pack-slot__change';
    change.textContent = 'cambiar';
    change.setAttribute('data-pack-choose', '');
    control.appendChild(change);

    slot.classList.add('is-filled');
    slot.classList.remove('has-error');
    slot.setAttribute('data-price', first.price);

    var opt = slot.closest('[data-pack-option]');
    if (opt) recalc(opt);
  }

  document.addEventListener('click', function (e) {
    var chooser = e.target.closest ? e.target.closest('[data-pack-choose]') : null;
    if (chooser) {
      e.preventDefault();
      var slot = chooser.closest('[data-pack-slot]');
      if (slot) openPicker(slot);
      return;
    }

    if (e.target.closest && e.target.closest('[data-pack-close]')) {
      e.preventDefault();
      closePicker();
      return;
    }

    var pick = e.target.closest ? e.target.closest('[data-pack-index]') : null;
    if (pick && activeSlot) {
      var index = parseInt(pick.getAttribute('data-pack-index'), 10);
      var product = catalog[index];
      if (product) fillSlot(activeSlot, product);
      closePicker();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && picker && !picker.hidden) closePicker();
  });

  /* ---------- Guía de tallas plegable ---------- */
  var sizeGuideBtn = document.querySelector('[data-open-size-guide]');
  var sizeGuideDetails = document.querySelector('[data-size-guide]');
  if (sizeGuideBtn && sizeGuideDetails) {
    sizeGuideBtn.addEventListener('click', function () {
      sizeGuideDetails.open = true;
      sizeGuideDetails.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------- Añadir al carrito ---------- */
  form.addEventListener('submit', function (e) {
    if (!packSelector) return;

    var opt = selectedOption();
    if (!opt) return;

    var qty = parseInt(opt.getAttribute('data-qty'), 10) || 1;
    if (qty === 1) return;

    e.preventDefault();

    var slots = opt.querySelectorAll('[data-pack-slot]');
    var incomplete = false;
    var counts = {};

    Array.prototype.forEach.call(slots, function (slot) {
      var control = slot.querySelector('[data-pack-variant]');
      var id = control ? control.value : '';
      if (!id) {
        incomplete = true;
        slot.classList.add('has-error');
        return;
      }
      counts[id] = (counts[id] || 0) + 1;
    });

    var errorEl = opt.querySelector('[data-pack-error]');
    if (incomplete) {
      if (errorEl) errorEl.hidden = false;
      var firstEmpty = opt.querySelector('.pack-slot.has-error');
      if (firstEmpty && firstEmpty.scrollIntoView) {
        firstEmpty.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }
    if (errorEl) errorEl.hidden = true;

    var items = Object.keys(counts).map(function (id) {
      return { id: parseInt(id, 10), quantity: counts[id] };
    });

    if (!items.length) return;

    var original = addButton ? addButton.innerHTML : '';
    if (addButton) {
      addButton.disabled = true;
      addButton.innerHTML = '<span>Añadiendo…</span>';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then(function () {
        if (addButton) {
          addButton.disabled = false;
          addButton.innerHTML = original;
        }
        var opener = document.querySelector('[data-cart-open]');
        if (opener) opener.click();
        else window.location.href = '/cart';
      })
      .catch(function () {
        if (addButton) {
          addButton.disabled = false;
          addButton.innerHTML = original;
        }
        window.location.href = '/cart';
      });
  });
})();